/** 用户token*/
function localSToken() {
    let name = "tmlklkjh"
    return {
        get() {
            return sessionStorage.getItem(name) || "";
        },
        set(value: string) {
            sessionStorage.setItem(name, value);
        }
    }
}

export {
    localSToken
}